<template>
  <span class="popoverOuter">
    <img v-if="target==null" class="target" ref="target" src="@/assets/img/questionmark-red.png">
    <a class="target_phone" ref="target" v-if="target=='phone'" href="tel:0800 243 779"><img src="@/assets/img/phone.png" style="width:15px;height:15px;" alt="0800 243 779"/></a>
    <div class="popoverContent" ref="inner" :style="{width: popoverWidth}">
      <slot />
    </div>
  </span>
</template>

<script>
import Popper from "popper.js";

export default {
  name: "MoreInfoPopover",
  props: ["width","target"],
  mounted() {
    let target = this.$refs.target;
    let inner = this.$refs.inner;

    //make a popper
	let popper = new Popper(target, inner, {
      placement: "bottom",
	});
	popper.scheduleUpdate()
    if(this.target=="phone"){
      target.parentElement.style.verticalAlign="baseline"
    }
  },
  methods: {
  },
  computed: {
      popoverWidth(){
          if(this.width){
              return this.width;
          }else{
              return "400px";
          }
      }
  }
};
</script>

<style lang="scss" scoped>
.popoverOuter {
  vertical-align: super;

  &:hover .popoverContent{
    visibility:visible;
    opacity: 1;
  }
}

.target{
  position:relative;
  margin:1px;
  height:12px;
  width:12px;
}

// .popoverContent {
//   z-index:2;
//   //opacity: 0;
//   //background-color: white;
//   //padding: 7px;
//   //border: 1px #212529 solid;
//   transition: opacity 0.2s ease-in-out;
//
//   // Style popover content
//   //text-align: left;
// }

.popoverContent{
  visibility:hidden;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  font-family: "Montserrat", sans-serif;
  display: inline-block;
  height: auto !important;
  padding:10px;
  border-radius: 10px;
  box-shadow: 2px 3px 10px 1px rgba(0, 0, 0, 0.5);
  background: white;
  border:1px solid lightgrey;
  z-index:10;
  opacity: 0;
  transition: opacity .2s ease-in-out;
  font-size: 12pt;
  text-align: left;
}

.popup-text:hover + .popup{
  opacity: 1;
}
</style>
